module.exports = __webpack_public_path__ + "static/img/official-stamp-3.d776892.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/official-stamp-3.png
// module id = cZPj
// module chunks = 8